// tempexp_18086-start
import { preloadImage } from '@mail/3promo/utils';
import ImageDark from 'img/aside-promo-modal/referral/referral-program-aside-promo-dark.webp';
import Image from 'img/aside-promo-modal/referral/referral-program-aside-promo-light.webp';
import ModalImageDark from 'img/referralProgramPromo/referral-program-modal-promo-dark.webp';
import ModalImage from 'img/referralProgramPromo/referral-promo-modal-light.webp';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    goToReferralSubscriptions,
    REFERRAL_ANALYTIC_NAME,
    REFERRAL_PROMO_ASIDE_PROMO_ID,
    REFERRAL_PROMO_SPACE_VISITS,
    referralProgramAsidePromoEnabled,
    referralProgramBonusQuota,
    referralProgramModalInsteadBalloon,
    referralProgramPromoSettings,
} from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { store as reduxStore } from 'reactApp/store';
import { openAsidePromoModal } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.helpers';
import { renderReferralModalPromo } from 'reactApp/ui/ReferralProgram/ReferralPromoModal/ReferralPromoModal.helper';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { getDays } from 'reactApp/utils/Period';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';
import { put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

const PRELOAD_TIMEOUT = 3 * 1000;

const sendAnalytic = (action: string) =>
    sendPaymentGa({
        action,
        eventCategory: referralProgramModalInsteadBalloon ? ECategoryGa.modal : ECategoryGa.balloon,
        name: REFERRAL_ANALYTIC_NAME,
    });

export function* initReferralProgramAsidePromo() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const isMobile = yield* select(EnvironmentSelectors.isMobile);

    const daysCount = getDays(referralProgramPromoSettings.asidePeriod);
    const periodPassed =
        storeHelper.getValue(REFERRAL_PROMO_ASIDE_PROMO_ID) && storeHelper.isPassed(REFERRAL_PROMO_ASIDE_PROMO_ID, { daysCount });

    if (periodPassed) {
        storeHelper.clearStore(REFERRAL_PROMO_ASIDE_PROMO_ID);
    }
    // показываем на /home
    // скрываем если фича выключена (внутри фичи исключаем платников, корпов, бизов и соцников)
    // скрываем на автотестых и таче
    // исключаем если период еще не прошел для показа
    if (!isHome || !referralProgramAsidePromoEnabled || isMobile || storeHelper.getValue(REFERRAL_PROMO_ASIDE_PROMO_ID)) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.referralProgramAsidePromo,
            promoId: REFERRAL_PROMO_ASIDE_PROMO_ID,
            onClick() {
                emitAnalyticEvent(AnalyticEventNames.REFERRAL_BALLON_CLICK);
                sendAnalytic('click');
                goToReferralSubscriptions();
                reduxStore.dispatch(removePromo(EPromoType.referralProgramAsidePromo));
            },
            onShow: () => {
                emitAnalyticEvent(AnalyticEventNames.REFERRAL_BALLON_SHOW);
                sendAnalytic('show');
                storeHelper.markAsShown(REFERRAL_PROMO_ASIDE_PROMO_ID);
                // очищаем счетчик заходов перед Space промо, для реинициализации показа Space промо
                storeHelper.setValue(REFERRAL_PROMO_SPACE_VISITS, 0);
                reduxStore.dispatch(promoShown(EPromoType.referralProgramAsidePromo));
            },
            onClose: () => {
                emitAnalyticEvent(AnalyticEventNames.REFERRAL_BALLON_CLOSE);
                sendAnalytic('close');
                reduxStore.dispatch(removePromo(EPromoType.referralProgramAsidePromo));
            },
        })
    );
}

export function* showReferralProgramAsideModal() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.referralProgramAsidePromo));
    const isDarkTheme = isDarkThemeModeEnabled();

    if (promo) {
        const { onShow, onClick, onClose } = promo;

        if (referralProgramModalInsteadBalloon) {
            const imageUrl = isDarkTheme ? ModalImageDark : ModalImage;
            yield preloadImage({ src: imageUrl, timeout: PRELOAD_TIMEOUT });
            yield renderReferralModalPromo({
                imageUrl,
                onClick,
                onShow,
                onClose,
                title: `Получите ${referralProgramBonusQuota.space}\u00A0${referralProgramBonusQuota.units} за\u00A0каждого друга`,
                text: `Рекомендуйте подписку Mail Space\u00A0- добавим место за\u00A0каждого, кто оплатит тариф по\u00A0вашей ссылке`,
                buttonText: 'Рекомендовать',
            });
        } else {
            const imageUrl = isDarkTheme ? ImageDark : Image;
            yield preloadImage({ src: imageUrl, timeout: PRELOAD_TIMEOUT });
            yield openAsidePromoModal({
                title: 'Рекомендуйте\nподписку Mail Space',
                text: `Добавим к\u00A0пространству\n +${referralProgramBonusQuota.space}\u00A0${referralProgramBonusQuota.units} за\u00A0каждого, кто подключит\n подписку по\u00A0вашей ссылке`,
                buttonText: 'Рекомендовать',
                imageUrl,
                showAboveViewer: true,
                onShow,
                onClick,
                onClose,
            });
        }
    }
}
// tempexp_18086-end
